import React from 'react';

function DollarSvg({ color = '#59585A', className = '', size = 24, props }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 26"
      {...props}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.232 1.204c-.488-.514-1.834-.023-3.007 1.095-1.17 1.117-1.725 2.437-1.238 2.95M16.017 2.887c.416-.712.521-1.36.214-1.683M11.99 5.25c.488.513 1.834.022 3.008-1.095.094-.09.184-.18.27-.274"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.99 5.25l1.137 1.192c.487.514 1.833.023 3.007-1.095 1.17-1.117 1.725-2.437 1.238-2.951l-1.137-1.192M3.62 6.262c.927-.667 2.906.51 4.429 2.621 1.522 2.115 2.006 4.365 1.08 5.032M3.546 9.213c-.532-1.35-.544-2.505.075-2.95M9.129 13.915c-.926.664-2.906-.51-4.429-2.62a.76.76 0 00-.048-.068"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.129 13.915l-2.153 1.55c-.926.667-2.906-.51-4.428-2.622-1.519-2.115-2.003-4.365-1.08-5.032L3.62 6.262M10.77 21.794c-1.106-1.174.176-4.178 2.86-6.705 2.686-2.527 5.76-3.626 6.867-2.448M13.587 21.966c-1.234.435-2.269.413-2.816-.172M20.5 12.637c1.107 1.173-.175 4.177-2.86 6.704a14.468 14.468 0 01-1.755 1.418"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.5 12.637l2.576 2.737c1.106 1.174-.176 4.177-2.861 6.705-2.685 2.527-5.76 3.626-6.866 2.448l-2.576-2.737"
      ></path>
    </svg>
  );
}

export default DollarSvg;
